import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { fromThemeColors } from '../Theme';
import { ButtonWrapper } from './GenericButton';
export var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n"])));
export var StyledButton = styled(ButtonWrapper)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\toverflow: visible;\n\tdisplay: block;\n\tline-height: 0;\n\tuser-select: none;\n\tborder-radius: 50%;\n\t", ";\n\t", ";\n\t:hover > :first-of-type {\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t}\n\t:focus > :first-of-type {\n\t\tborder-radius: 50%;\n\t\tbox-shadow: 0 0 0 2px ", ";\n\t}\n"])), function (props) {
  return props.active && 'background-color: rgba(0, 0, 0, 0.15)';
}, function (props) {
  return props.active && 'opacity: 1';
}, function (props) {
  return !props.active && props.disabled ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0.15)';
}, fromThemeColors('focus'));